import { DefaultButton } from 'components/button/DefaultButton';
import { PasswordInput } from 'components/forms/PasswordInput';
import { ValidatableLabel } from 'components/forms/ValidatableLabel';
import { ValidationSummary } from 'components/forms/ValidationSummary';
import { LoginForm, ResetPasswordButton, StyledTextInput } from 'pages/Login/Login';
import * as React from 'react';
import {
    Control,
    Controller,
    FieldError,
    RegisterOptions,
    UseFormRegister,
} from 'react-hook-form';

const passwordRules: RegisterOptions = {
    required: 'Please enter your password.',
};

export type PasswordScreenProps = {
    email: string;
    register: UseFormRegister<LoginForm>;
    control: Control<LoginForm>;
    passwordErrors: FieldError | undefined;
    onLogin: () => void;
    onSubmit: (event: React.FormEvent) => void;
    onResetPassword: () => void;
    errorMessage?: string;
    onChange?: () => void;
    actionable: boolean;
};

export function PasswordScreen({
    email,
    control,
    register,
    passwordErrors,
    onLogin,
    onSubmit,
    onResetPassword,
    errorMessage,
    onChange,
    actionable,
}: PasswordScreenProps) {
    register('password', passwordRules);

    return (
        <form onSubmit={onSubmit}>
            {/* The hidden input allows the email/form state to get carried across renders */}
            <StyledTextInput type="hidden" value={email} {...register('email')} />
            {errorMessage && (
                <ValidationSummary className="mb-20">{errorMessage}</ValidationSummary>
            )}
            <ValidatableLabel label="Password" className="mb-16" error={passwordErrors}>
                <Controller
                    control={control}
                    name="password"
                    rules={passwordRules}
                    render={({ field: { value, onChange: fieldOnChange, onBlur } }) => (
                        <PasswordInput
                            placeholder="Enter your password"
                            autofocus
                            invalid={passwordErrors !== undefined}
                            name="password"
                            value={value}
                            onChange={(event) => {
                                onChange?.();
                                fieldOnChange(event);
                            }}
                            onBlur={onBlur}
                        />
                    )}
                />
            </ValidatableLabel>
            <footer className="flex-column">
                <div>
                    <DefaultButton
                        type="button"
                        onClick={onLogin}
                        disabled={!actionable}
                        aria-label="Log In"
                    >
                        Log In
                    </DefaultButton>
                </div>
                <div className="pt-40">
                    <ResetPasswordButton
                        type="button"
                        onClick={onResetPassword}
                        aria-label="Forgot Password"
                    >
                        Forgot Password
                    </ResetPasswordButton>
                </div>
            </footer>
        </form>
    );
}
